import { render, staticRenderFns } from "./labelSystemGroup.vue?vue&type=template&id=640f4266&scoped=true&"
import script from "./labelSystemGroup.vue?vue&type=script&lang=js&"
export * from "./labelSystemGroup.vue?vue&type=script&lang=js&"
import style0 from "./labelSystemGroup.vue?vue&type=style&index=0&id=640f4266&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f4266",
  null
  
)

component.options.__file = "labelSystemGroup.vue"
export default component.exports